// ==== helper functions === //

// list of most common symbols
const symbols = {
	"&#39;" : "'",
	"&amp;" : "&",
  };
  
  // replaces symbols with the appropriate strings
  const replaceSymbols = (text, symbols) => {
	let newText = `${text}`;
	for ( const symbol in symbols ) {
		newText = newText.replace(new RegExp(symbol, 'g'), symbols[symbol])
	}
	return newText;
  }
  
  window.addEventListener('DOMContentLoaded', (event) => {
	let selectors = {
	  video: ".giftVideo video",
	  videoPopUp: ".videoPopUp",
	  landingContent: ".giftLanding",
	  giftImage: ".giftLanding__imageWrapper img",
	  recepient: ".giftLanding__contentTitle",
	  message: ".giftLanding__contentDescription",
	  products: ".giftLanding__products",
	  printButton: ".giftLanding__printIcon",
  
	  landingVisibleClass: "giftLanding--visible",
	  visibleClass: "videoPopUp--visible"
	};
  
	let slickSettings = {
	  infinite: false,
	  slidesToShow: 3,
	  slidesToScroll: 1,
	  dots: true,
	  arrows: false,
	  responsive: [
		{
		  breakpoint: 750,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		}
	  ]
	};
	let params = new URLSearchParams(window.location.search);
	let giftVideoElements = document.querySelectorAll(selectors.video);
	let videoPopUp = document.querySelector(selectors.videoPopUp);
	let landingContentElement = document.querySelector(selectors.landingContent);
	let giftImageElement = document.querySelector(selectors.giftImage);
	let recepientElement = document.querySelector(selectors.recepient);
	let messageElement = document.querySelector(selectors.message);
	let productIDs = params.get("ids") ? params.get("ids").slice(0, -1).split(',') : [];
	let productQuantities = params.get("quantities") && params.get("quantities").slice(0, -1).split(',');
	let productsElement = document.querySelector(selectors.products);
	let printButtonElement = document.querySelector(selectors.printButton);
  
	giftVideoElements.forEach(video => {
	  let interval = setInterval(() => {
		if (video.currentTime >= 2) {
		  video.pause();
		  if(videoPopUp) {
			videoPopUp.classList.add(selectors.visibleClass);
		  }
		  clearInterval(interval);
		}
	  }, 100);
	})
  
	if(printButtonElement) {
	  printButtonElement.addEventListener("click", () => {
		if (productIDs.length >= 4) {
		  $('.giftLanding__products').slick('unslick');
		}
		window.print();
	  });
	}
  
	window.onafterprint = function(){
	  if (productIDs.length >= 4) {
		$('.giftLanding__products').slick(slickSettings);
	  }
   }
  
	if (landingContentElement) {
	  giftImageElement.src = params.get("image");
	  
	  const rcp = replaceSymbols(params.get("rcp"), symbols);
	  const msg = replaceSymbols(params.get("msg"), symbols);
	  const from = replaceSymbols(params.get("from"), symbols);
  
	  recepientElement.innerText = `Dear ${rcp},`;
	  messageElement.innerText = `${msg}\n\n With love,\n${from}`;
	  const products_innerText = document.querySelector("#products").innerText;
	  const productsObject = JSON.parse(products_innerText);
  
	  productIDs.forEach((id, i) => {
		var quantity = '';
		if (productQuantities && productQuantities[i] > 1) {
		  quantity = ' X' + productQuantities[i];
		}
  
	  const ProductDescription = ( productsObject && productsObject[id] && productsObject[id].product_description ) ?
		`<p class="product_description_text">${productsObject[id].product_description}</p>`
		: '';
  
	  const ProductImage = ( productsObject && productsObject[id] && productsObject[id].image ) ?
	  `<img src="${productsObject[id].image}" alt="${productsObject[id].title || "untitled"}" />`
	  : '';
  
	  const ProductTitle = ( productsObject && productsObject[id] && productsObject[id].title ) ?
	  `<h4>${productsObject[id].title}${quantity}</h4>`
	  : '';
  
  
	  const productLayout = `
		<div class="product">
		  ${ProductImage}
		  ${ProductTitle}
		  ${ProductDescription}
		</div>
	  `;
  
		productsElement.insertAdjacentHTML("beforeend", productLayout);
	  })
  
	  if (productIDs.length >= 4) {
		$('.giftLanding__products').slick(slickSettings);
	  }
	}
  
	if (videoPopUp) {
	  videoPopUp.addEventListener("click", (event) => {
		continueVideo(event.currentTarget, giftVideoElements, landingContentElement);
	  });
	}
  
	function continueVideo(target, videos, landing) {
	  let videoDuration;
	  videos.forEach(video => {
		videoDuration = (video.duration * 1000 - 2300).toFixed(0)
		video.play();
	  })
	  target.classList.remove(selectors.visibleClass);
	  setTimeout(() => {
		landing.classList.add(selectors.landingVisibleClass);
	  }, videoDuration);
	}
  });